import { GET_FOLLOWING } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_FOLLOWING:
            return action.payload;
        default:
            return state;
    }
}